import { createApp } from 'vue'
import App from './App.vue'
import router from './router' // ルーターファイルをインポート
import './assets/css/input.css'

const app = createApp(App)

// アプリケーションにルーターを適用
app.use(router)

app.mount('#app')
